export default __webpack_public_path__ + "static/media/portfolio-195.032f69eb.jpg";